import { useState } from 'react';
import styles from '../dash_styles/shipping.module.css';

import CurrencyDisplay from './CurrencyDisplay';
import getDate from './getDate';

const Shipping = () => {
    const [shipping, setShipping] = useState(null);

    return (
        <div className={styles.mainContainer}>
            <div className={styles.shipping}>
                <div className={styles.outerTable}>
                    <table>
                        <thead>
                            <tr>
                                <th className={styles.col1}>tracking#</th>
                                <th className={styles.col2}>status</th>
                                <th className={styles.col3}>shipped date</th>
                                <th className={styles.col3}>carrier</th>
                                <th className={styles.col5}>shipping cost</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Array.isArray(shipping) && shipping.map(s => (
                                <tr key={s.id}>
                                    <td><p>FED-02340{s.id}</p></td>
                                    <td><p>{s.status}</p></td>
                                    <td><p>{getDate(s.created_at)}</p></td>
                                    <td><p>{s.payment_method}</p></td>
                                    <td><CurrencyDisplay amount={s.total} currency='CAD'/></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            {!shipping && (
                    <div style={{
                        height: '100%',
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <p>You currently have no shipped orders</p>
                        <p style={{fontWeight: 400, marginTop: '10px'}}>Add shipping through order</p>
                    </div>
                )}
        </div>
    );
};

export default Shipping;